import React, { useState, useEffect } from "react";
import euaImg from "../assets/icons/sidebar/eua.svg";
import complainceImg from "../assets/icons/sidebar/compliance.svg";
import estimationImg from "../assets/icons/sidebar/estimation.svg";
import feumImg from "../assets/icons/sidebar/feum.svg";
import newsRoomImg from "../assets/icons/sidebar/NewsRoomImg.svg";
// import frame from "../assets/icons/sidebar/Frame.svg";
import frame from "../assets/icons/sidebar/Frame-cropped.svg";
import logoutImg from "../assets/icons/sidebar/Logout.svg";
import addVesselImg from "../assets/icons/sidebar/add-vessel.svg"
import rawdataImg from "../assets/icons/sidebar/RawData.svg"
import casperAnalysisImg from "../assets/icons/rawdata/casper-analysis.svg"
import vessalAnalysisImg from "../assets/icons/rawdata/tabler_ship.svg"
import usermanagementImg from "../assets/icons/sidebar/Usermanagementactive.svg"
import opti from "../assets/icons/sidebar/Optimize.svg"
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip, Badge } from "antd";
// import userProfile from "../assets/icons/sidebar/user.jpg";
import userProfile from "../assets/icons/sidebar/userProfile.svg"
import { togglePastRecordsFalse } from "../features/RawData/RawDataSlice";
import { useLocation } from "react-router-dom";
import vesselDetailsImg from "../assets/icons/sidebar/shippool.svg"
import PoolingImg from "../assets/icons/sidebar/pooling.svg"
import userManagementImg from "../assets/icons/userManagementImg.svg"
import prevPoolingImg from "../assets/icons/sidebar/check-list.svg"
import onboardingImg from "../assets/images/shipVessel.png"
import vesselImg from "../assets/icons/sidebar/VesselImg.svg";
import voyageImg from "../assets/icons/sidebar/VoyageImg.svg";
import notificationImg from "../assets/icons/sidebar/NotificationImg.svg";
import { notificationList } from '../features/AutoPooling/AutoPoolingSlice';


const Sidebar = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation();
  const { user } = useSelector((state) => state.user);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isHovered, setIsHovered] = useState(false);
  const [isPathMatrixTable, setIsMatrixPath] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    dispatch(notificationList({
      request_type: "all",
      requested_page_number: 1,
      period: ""
    }));
  }, [dispatch])

  const { NotificationListData } = useSelector((state) => state.autoPooling); // Assuming `totalNotifications` comes from the backend


  const SidebarDataAll = [
    {
      title: "Compliance Exposure",
      image: complainceImg,
      link: "/dashboard"
    },
   
    {
      title: "FEUM Overview",
      image: feumImg,
      link: "/vessels"
    },
    {
      title: "EUA Overview",
      image: euaImg,
      link: "/voyages"
    },
     {
      title: "Estimation",
      image: estimationImg,
      link: "/freemium"
    },
    // {
    //   title: "Notification",
    //   image: notificationImg,
    //   link: "/notifications",
    // },
    {
      title: "News Room",
      image: newsRoomImg,
      link: "/newsroom"
    },
    // {
    //   title: "EFDB",
    //   image: efdbImg,
    //   link: "/efdb"
    // },
    {
      title: "Voyage Optimization",
      image: opti,
      link: "/voyage-optimization"
    },
    {
      title: "Raw Data",
      image: rawdataImg,
      link: "/raw-data"
    },
    {
      title: "Casper Analysis",
      image: casperAnalysisImg,
      link: "/casper-analysis"
    },
    {
      title: "Vessel Analysis",
      image: vessalAnalysisImg,
      link: "/vessels-analysis"
    },
    // {
    //   title: "User Management",
    //   image: usermanagementImg,
    //   link: "/user-management"
    // },
    {
      title: "Logout",
      image: logoutImg,
    },
  ]

  const SidebarDataFirst = [
    {
      title: "Compliance Exposure",
      image: complainceImg,
      link: "/dashboard"
    },
    {
      title: "Estimation",
      image: estimationImg,
      link: "/freemium"
    },
    {
      title: "FEUM Overview",
      image: feumImg,
      link: "/vessels"
    },
    {
      title: "EUA Overview",
      image: euaImg,
      link: "/voyages"
    },
    // {
    //   title: "Notification",
    //   image: notificationImg,
    //   link: "/notifications",
    // },
    {
      title: "News Room",
      image: newsRoomImg,
      link: "/newsroom"
    },
    // {
    //   title: "EFDB",
    //   image: efdbImg,
    //   link: "/efdb"
    // },
    {
      title: "Voyage Optimization",
      image: opti,
      link: "/voyage-optimization"
    },
  ]

  const SidebarDataPooling = [
    {
      title: "Estimation",
      image: estimationImg,
      link: "/freemium"
    },
    ...(user.role === "Pooling Agent" ? [{
      title: "Onboard New Vessel",
      image: addVesselImg,
      link: "/OnBoarding"
    },
    ] : []),
    {
      title: "Vessel Details",
      image: vesselDetailsImg,
      link: "/dashboard"
    },
    ...(user.role === "Admin Pooling Agent" ? [
      {
        title: "Manual Pooling",
        image: PoolingImg,
        link: "/pooling"
      },
    ] : []),
    ...(user.role === "Pooling Agent" ? [
      {
        title: "Auto Pooling",
        image: PoolingImg,
        link: "/VesselAutoPooling"
      },
    ] : []),
    // ...(user.role === "Pooling Agent" ? [
    {
      title: "Notifications",
      image: notificationImg,
      link: "/poolingNotifications"
    },
    // ] : []),
    {
      title: "Pool Overview",
      image: prevPoolingImg,
      link: "/poolingHistory"
    },
    ...(user.role === "Admin Pooling Agent" ? [
      {
        title: "User Management",
        image: userManagementImg,
        link: "/user-management"
      },
    ] : []),

     {
      title: "News Room",
      image: newsRoomImg,
      link: "/newsroom"
    },
  ]


  const SidebarFreemium = [
    {
      title: "Estimation",
      image: estimationImg,
      link: "/freemium"
    },
  ]

  const handleNavigationPooling = () => {
    navigate('/OnBoarding', { state: { rowData: null, type: "new" } });
  };

  const [isBottom, setIsBottom] = useState(window.innerWidth < 1500);

  const handleHamburgerClick = () => {
    setIsMatrixPath((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("user")
    window.location.href = '/login'
  };

  const handleNavigation = (navLink) => {
    if (user.role !== "Freemium") {
      if (user.role === "ems") {
        if (navLink === "/dashboard" || navLink === "/casper-analysis") {
          dispatch(togglePastRecordsFalse())
        }
      }
      if (navLink === "/OnBoarding") {
        navigate(navLink, { state: { rowData: null, type: "new" } })
      } else {
        navigate(navLink)
      }
    }
  };

  useEffect(() => {
    setShowTooltip(user.role === "Freemium");
  }, [user.role]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);


  return (
    <div className={`${isPathMatrixTable ? "MatrixTableSideBar" : "sideBar"} ${isHovered ? "expanded" : "collapsed"
      }`}
      onMouseEnter={() => (setIsHovered(true), setIsMatrixPath(false))}
      onMouseLeave={() => (setIsHovered(false), setIsMatrixPath(true))}
    >
      <div className="hamburger-menu" onClick={handleHamburgerClick}>
        <div className="hamburger-icon">
          <span />
          <span />
          <span />
        </div>
        {isHovered && !isPathMatrixTable ? (user.role == "Admin Pooling Agent" || user.role == "Pooling Agent") ? <span className="PoolDive">POOL DIVE</span> : <span className="PoolDive">CASPER</span> : ''}
      </div>

      {/* ℙ𝕆𝕆𝕃 𝔻𝕀𝕍𝔼  */}
      {
        user.role === "Ship Owner" || user.role === "DOC" ?
          (<div className="sideBar-navigation-ems">
            <div className="sideBar-userProfile">
              <div className={
                isPathMatrixTable ? "MatrixTableSideBardiv" :
                  "sideBar-userProfile-image"}>
                <img className={
                  isPathMatrixTable ? "MatrixTableSideBarImg" :
                    ""} src={userProfile} alt="User Profile" />
              </div>
              {isPathMatrixTable ? '' :
                <div className="sideBar-userProfile-text">
                  <p>Hello,</p>
                  <h1>{user?.username}</h1>
                </div>
              }
            </div>
            <div className="sidebar-white-divider" />
            <div>
              {SidebarDataFirst.map((navData, i) => (
                <div key={i} className={
                  isPathMatrixTable ? "MatrixTableSideBarNavigationEle" :
                    "sideBar-navigation-elements"} id={window.location.pathname === navData.link ? "active" : ""}>
                  <div className="sideBar-elements" onClick={() => handleNavigation(navData.link)}>
                    <div className="sideBar-elements-Image">
                      {isPathMatrixTable ?
                        <Tooltip placement="right" title={navData.title}>
                          <img style={{ width: '20px', transform: navData.title === "FEUM Overview" ? 'rotate(20deg)' : 'none' }} src={navData.image} alt={navData.title} />
                        </Tooltip>
                        :
                        <img style={{ width: '20px', transform: navData.title === "FEUM Overview" ? 'rotate(20deg)' : 'none' }} src={navData.image} alt={navData.title} />
                      }
                    </div>

                    {isPathMatrixTable ? '' :
                      <div className="sideBar-elements-Text">
                        {showTooltip && (
                          <Tooltip
                            title="The feature is exclusively accessible to basic plan users only."
                            color="#FF8585"
                          >
                            <p>{navData.title}</p>
                          </Tooltip>
                        )}
                        {!showTooltip && (

                          <p>{navData.title}</p>

                        )}
                      </div>
                    }


                  </div>
                </div>
              ))}
            </div>
            <div className="user-management">
              <div className="sidebar-white-divider" />
              <div className="sideBar-logout" style={{ display: "flex", cursor: "pointer" }} onClick={() => handleLogout()}>
                <div className="sideBar-elements-Image">
                  {isPathMatrixTable ?
                    <Tooltip placement="right" title={"Logout"}>
                      <img style={{ width: '20px' }} src={logoutImg} alt={"Logout"} />
                    </Tooltip> :
                    <img style={{ width: '20px' }} src={logoutImg} alt={"Logout"} />}
                </div>
                {isPathMatrixTable ? '' :
                  <div className="sideBar-elements-Text">
                    <p>Logout</p>
                  </div>}
              </div>
            </div>



          </div>)

          :

          user.role == "Admin Pooling Agent" || user.role == "Pooling Agent" ?
            (
              <div className="sideBar-navigation-pooling">
                {isPathMatrixTable ? "" : <div><br /><br /></div>}
                <div className="sideBar-userProfile">
                  <div className={
                    isPathMatrixTable ? "MatrixTableSideBardiv" :
                      "sideBar-userProfile-image"}>
                    <img className={
                      isPathMatrixTable ? "MatrixTableSideBarImg" :
                        ""} src={userProfile} alt="User Profile" />
                  </div>
                  {isPathMatrixTable ? '' :
                    <div className="sideBar-userProfile-text">
                      <p>Hello,</p>
                      <h1>{user?.username}</h1>
                    </div>
                  }
                </div>
                <div className="sidebar-white-divider" />
                <div className="sidebar-data">
                  <div>
                    {SidebarDataPooling.map((navData, i) => {
                      const isPoolingNotifications = navData.link === "/poolingNotifications";
                      const badgeCount = NotificationListData?.tab_count?.pending;
                      return (<div
                        key={i}
                        className={isPathMatrixTable ? "MatrixTableSideBarNavigationEle" : "sideBar-navigation-elements"}
                        id={window.location.pathname === navData.link ? "active" : ""}
                      >
                        <div className="sideBar-elements" onClick={() => handleNavigation(navData.link)}>
                          <div className="sideBar-elements-Image">
                            {isPathMatrixTable ? (
                              <Tooltip placement="right" title={navData.title}>
                                {isPoolingNotifications && badgeCount > 0 ? (
                                  <Badge
                                    count={badgeCount}
                                    style={{
                                      fontSize: '7px',
                                      height: '14px',
                                      minWidth: '14px',
                                      lineHeight: '14px',
                                      padding: 0,
                                      boxShadow: 'none',
                                    }}
                                    offset={[-2, 2]} // Adjust this to fit top-right inside 20x20 icon
                                  >
                                    <img
                                      style={{ width: '20px', height: '20px', position: 'relative' }}
                                      src={navData.image}
                                      alt={navData.title}
                                    />
                                  </Badge>

                                ) : (
                                  <img style={{ width: "20px" }} src={navData.image} alt={navData.title} />
                                )}
                              </Tooltip>
                            ) : (
                              isPoolingNotifications && badgeCount > 0 ? (
                                <Badge
                                  count={badgeCount}
                                  style={{
                                    fontSize: '7px',
                                    height: '14px',
                                    minWidth: '14px',
                                    lineHeight: '14px',
                                    padding: 0,
                                    boxShadow: 'none',
                                  }}
                                  offset={[-2, 2]} // Adjust this to fit top-right inside 20x20 icon
                                >
                                  <img
                                    style={{ width: '20px', height: '20px', position: 'relative' }}
                                    src={navData.image}
                                    alt={navData.title}
                                  />
                                </Badge>
                              ) : (
                                <img style={{ width: "20px" }} src={navData.image} alt={navData.title} />
                              )
                            )}
                          </div>

                          {isPathMatrixTable ? (
                            ""
                          ) : (
                            <div className="sideBar-elements-Text">
                              {showTooltip ? (
                                <Tooltip
                                  title="This feature is only available for premium users."
                                  color="#FF8585"
                                >
                                  <p>{navData.title}</p>
                                </Tooltip>
                              ) : (
                                <p>{navData.title}</p>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      )
                    })}
                  </div>

                  {/* {isHovered ?
                    <div className="sidebarPooling-container" style={{ backgroundImage: `url(${onboardingImg})` }}>
                      <div className="sidebarPooling-content">
                        <p className="sidebarPooling-subheading">Onboard a new</p>
                        <p className="sidebarPooling-heading">VESSEL</p>
                        <button className="sidebarPooling-button" onClick={handleNavigationPooling}>
                          Add Vessel
                        </button>
                      </div>
                    </div>
                    :
                    <img className="sidebarPooling-button-not-hovered" src={addVesselImg} onClick={handleNavigationPooling} />

                  }
                    */}
                  <div className="user-management">
                    <div className="sidebar-white-divider" />
                    <div className="sideBar-logout" onClick={() => handleLogout()}>
                      <div className="sideBar-elements" style={isHovered ? {} : { display: "flex", justifyContent: "center", marginRight: '3px' }}>
                        <div className="sideBar-elements-Image">
                          <Tooltip placement="right" title={"Logout"}>
                            <img style={{ width: '20px' }} src={logoutImg} alt={"Logout"} />
                          </Tooltip>
                        </div>
                        {isHovered && !isPathMatrixTable ?
                          <div className="sideBar-elements-Text">
                            <p>Logout</p>
                          </div>
                          :
                          ""
                        }
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            )
            :

            user.role == 'Freemium' ?
              (<div className="sideBar-navigation-freemium">
                <div className="sideBar-userProfile">
                  <div className={
                    isPathMatrixTable ? "MatrixTableSideBardiv" :
                      "sideBar-userProfile-image"}>
                    <img className={
                      isPathMatrixTable ? "MatrixTableSideBarImg" :
                        ""} src={userProfile} alt="User Profile" />
                  </div>
                  {isPathMatrixTable ? '' :
                    <div className="sideBar-userProfile-text">
                      <p>Hello,</p>
                      <h1>{user?.username}</h1>
                    </div>
                  }
                </div>
                <div className="sidebar-white-divider" />
                <div>
                  {SidebarFreemium.map((navData, i) => (
                    <div key={i} className={
                      isPathMatrixTable ? "MatrixTableSideBarNavigationEle" :
                        "sideBar-navigation-elements"} id={window.location.pathname === navData.link ? "active" : ""}>
                      <div className="sideBar-elements" onClick={() => handleNavigation(navData.link)}>
                        <div className="sideBar-elements-Image">
                          {isPathMatrixTable ?
                            <Tooltip placement="right" title={navData.title}>
                              <img style={{ width: '20px', transform: navData.title === "FEUM Overview" ? 'rotate(20deg)' : 'none' }} src={navData.image} alt={navData.title} />
                            </Tooltip>
                            :
                            <img style={{ width: '20px', transform: navData.title === "FEUM Overview" ? 'rotate(20deg)' : 'none' }} src={navData.image} alt={navData.title} />
                          }
                        </div>

                        {isPathMatrixTable ? '' :
                          <div className="sideBar-elements-Text">
                            {showTooltip && (
                              <Tooltip
                                title="The feature is exclusively accessible to basic plan users only."
                                color="#FF8585"
                              >
                                <p>{navData.title}</p>
                              </Tooltip>
                            )}
                            {!showTooltip && (

                              <p>{navData.title}</p>

                            )}
                          </div>
                        }


                      </div>
                    </div>
                  ))}
                </div>
                <div className="user-management user-management-freemium">
                  <div className="sidebar-white-divider" />
                  <div className="sideBar-logout" style={{ display: "flex", cursor: "pointer", justifyContent: isPathMatrixTable ? 'center' : 'left' }} onClick={() => handleLogout()}>
                    <div className="sideBar-elements-Image">
                      {isPathMatrixTable ?
                        <Tooltip placement="right" title={"Logout"}>
                          <img style={{ width: '20px' }} src={logoutImg} alt={"Logout"} />
                        </Tooltip> :
                        <img style={{ width: '20px' }} src={logoutImg} alt={"Logout"} />}
                    </div>
                    {isPathMatrixTable ? '' :
                      <div className="sideBar-elements-Text">
                        <p>Logout</p>
                      </div>}
                  </div>
                </div>



              </div>)
              :
              (<div className="sideBar-navigation">
                <div className="sideBar-userProfile">
                  <div className={
                    isPathMatrixTable ? "MatrixTableSideBardiv" :
                      "sideBar-userProfile-image"}>
                    <img className={
                      isPathMatrixTable ? "MatrixTableSideBarImg" :
                        ""} src={userProfile} alt="User Profile" />
                  </div>
                  {isPathMatrixTable ? '' :
                    <div className="sideBar-userProfile-text">
                      <p>Hello,</p>
                      <h1>{user?.username}</h1>
                    </div>
                  }
                </div>
                <div className="sidebar-white-divider" />
                {SidebarDataAll.map((navData, i) => (
                  <>
                    {navData.title == "Logout" ?
                      <div className="sidebar-white-divider" />
                      :
                      ""
                    }
                    <div key={i} className={isPathMatrixTable ? "MatrixTableSideBarNavigationEle" : "sideBar-navigation-elements"} id={window.location.pathname === navData.link ? "active" : ""}>
                      <div className="sideBar-elements" onClick={navData.title === "Logout" ? () => { handleLogout() } : () => { handleNavigation(navData.link) }}>
                        <div className="sideBar-elements-Image">
                          {isPathMatrixTable ?
                            // <Tooltip placement={isBottom ? "bottom" : 'right'} title={navData.title}>
                            <Tooltip placement={'right'} title={navData.title}>
                              <img style={{ width: '20px', transform: navData.title === "FEUM Overview" ? 'rotate(20deg)' : 'none' }} src={navData.image} alt={navData.title} />
                            </Tooltip>
                            :
                            <img style={{ width: '20px', transform: navData.title === "FEUM Overview" ? 'rotate(20deg)' : 'none' }} src={navData.image} alt={navData.title} />}
                        </div>

                        {isPathMatrixTable ? '' :
                          <div className="sideBar-elements-Text">
                            {showTooltip && navData.title !== "Logout" && (
                              <Tooltip
                                title="The feature is exclusively accessible to basic plan users only."
                                color="#FF8585"
                              >
                                <p>{navData.title}</p>
                              </Tooltip>
                            )}
                            {navData.title === "Logout" && (

                              <p>{navData.title}</p>

                            )}

                            {!showTooltip && navData.title !== "Logout" && (

                              <p>{navData.title}</p>

                            )}
                          </div>}


                      </div>
                    </div>
                  </>
                ))}
              </div>)
      }

      {isPathMatrixTable ? '' : <div className="sideBar-date">
        {/* <div className="sideBar-date-elem1">
          <p>GMT</p>
        </div>
        <div className="sideBar-date-elem2">
          <h1>{formattedTime}</h1>
        </div>
        <div className="sideBar-date-elem3">{formattedDate}</div> */}
      </div>}


      {isPathMatrixTable ? '' :
        <div className="sideBar-logo">
          {user?.username === "testdemo" ? '' : <img src={frame} alt="Azolla" />}
        </div>}
    </div>
  );
};

export default Sidebar;
